import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import {
  CustomQuestionSaveButton,
  ReportCustomQuestionTypePropsBase,
  StyledCustomQuestionType,
  htmlToPlainText,
} from './utils';
import CustomQuestionTop from './CustomQuestionTop';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import { useSaveSurveyAnswer } from './hooks';
import CustomQuestionShow from './CustomQuestionShow';

const StyledDiv = styled(StyledCustomQuestionType)``;

const CustomQuestionText: React.FC<ReportCustomQuestionTypePropsBase> = ({
  question,
  answer,
  saveButtonText,
  customQuestionIndex,
  customQuestion,
  questionIndex,
  reportId,
  disableEdit,
  initialEdit,
  onChange,
  handleAddDoneQuestionId,
  handleRemoveDoneQuestionId,
}) => {
  const a = answer[0] || {};
  const initialAnswer = a.value || '';
  const [text, setText] = useState<string>(initialAnswer);
  const {
    requestState,
    isEdit,
    handleShowEdit,
    handleCancelEdit,
    handleSaveSurveyAnswer,
  } = useSaveSurveyAnswer({
    onChange,
    initialAnswer,
    initialEdit,
    handleAddDoneQuestionId,
    handleRemoveDoneQuestionId,
    question,
    customQuestionIndex,
    customQuestion,
    questionIndex,
    reportId,
  });

  const handleSubmit = useCallback(() => {
    if (!text) return;
    handleSaveSurveyAnswer({
      answerId: a.dbId,
      answer: {
        dbId: undefined,
        optionId: undefined,
        value: text,
      },
    });
  }, [onChange, text]);

  const handleCancel = useCallback(() => {
    setText(initialAnswer);
    handleCancelEdit();
  }, [initialAnswer, handleCancelEdit]);

  if (!isEdit || disableEdit) {
    return (
      <CustomQuestionShow
        answer={{
          questionType: 'text',
          answer: text,
        }}
        question={question}
        disableEdit={disableEdit}
        handleEdit={handleShowEdit}
      />
    );
  }

  return (
    <StyledDiv>
      <CustomQuestionTop
        title={question.questionText}
        helperText={question.helperText}
        questionType={question.questionType}
      />
      <TrueImpactTextfield
        value={text}
        isTextarea={true}
        onChange={setText}
        placeholder={htmlToPlainText(question.helperText)}
      />
      <CustomQuestionSaveButton
        disabled={!text}
        text={saveButtonText}
        requestState={requestState}
        handleSubmit={handleSubmit}
        handleCancel={initialAnswer ? handleCancel : undefined}
      />
    </StyledDiv>
  );
};

export default CustomQuestionText;
